import { AlertType, CompType } from '@aloft/toolkit-shared';

export const getCompTypeLabel = (compType: CompType): string =>
  compType === 'aiv' ? 'AIV' : 'ARV';

export const getScopedAlertType = (base: string, compType?: CompType): AlertType =>
  (compType ? `${base}${compType === 'aiv' ? 'Aiv' : 'Arv'}` : base) as AlertType;

export const getComparableDisplayName = (propertyID: string, compSequence?: string[]): string => {
  const match = /^comp(\d+)$/.exec(propertyID);
  if (match) return `Comparable ${match[1]}`;

  const index = compSequence?.indexOf(propertyID);
  if (index !== undefined && index >= 0) return `Comparable ${index + 1}`;

  return propertyID;
};
